import React from "react";
import {
  PublishBanner,
  Navigation,
  Footer,
  Image,
  CopyrightLabel,
  OutboundLink,
  SocialMedia,
  SiteMap,
  FishermanBanner,
  HoursOfOperation,
  Location
} from "../../../../../../packages/components/src";
import { graphql, StaticQuery } from "gatsby";

import "semantic-ui-less/semantic.less";

export default ({ children }) => (
  <StaticQuery
    query={graphql`
      query {
        fishermanBusiness {
          _id
          type
          name
          website {
            cloudformationStackName
          }
          primaryLocation {
            phoneNumber
            email
            street
            city
            state
            zipCode
            hours {
              day
              open
              close
              label
            }
          }
          gatsbyLogo {
            childImageSharp {
              fixed(height: 60) {
                base64
                width
                height
                src
                srcSet
              }
            }
          }
          socialMedia {
            link
            type
          }
        }
        allFishermanBusinessWebsitePage(
          sort: { order: ASC, fields: navigationPriority }
        ) {
          nodes {
            title
            slug
            pageType
            url
            navigationPriority
            groupName
            props
          }
        }
      }
    `}
    render={(data) => {
      const { fishermanBusiness, allFishermanBusinessWebsitePage } = data;

      return (
        <React.Fragment>
          <div className={"site-container"}>
            <div>
              {/*<PublishBanner*/}
                {/*business={{*/}
                  {/*id: fishermanBusiness._id,*/}
                  {/*type: fishermanBusiness.type,*/}
                  {/*name: fishermanBusiness.name,*/}
                {/*}}*/}
                {/*defaultDomain={*/}
                  {/*fishermanBusiness.website.cloudformationStackName*/}
                {/*}*/}
                {/*defaultShowBanner={true}*/}
                {/*collectEmail={false}*/}
                {/*enablePopup={false}*/}
              {/*/>*/}
              <Navigation
                links={[
                  ...allFishermanBusinessWebsitePage.nodes.slice(0, 4),
                  {
                    title: 'Order Online',
                    slug: '/order-online/',
                    pageType: 'OrderOnline',
                    navigationPriority: 5,
                    props: allFishermanBusinessWebsitePage.nodes[4].props
                  }
                ]}
                bordered={false}
                centerMobileNavItems={true}
                fixed={false}
                header={fishermanBusiness.name}
                logo={fishermanBusiness.gatsbyLogo.childImageSharp}
                linksAs={"text"}
                primaryContentCentered={true}
              />
            </div>
            <div className={"page-container"}>{children}</div>
            <Footer
              backgroundColor={"primary"}
              horizontalAlign={"center"}
              verticalAlign={"middle"}
              columns={[
                <Location
                  businessName={fishermanBusiness.name}
                  phone={fishermanBusiness.primaryLocation.phoneNumber}
                  email={fishermanBusiness.primaryLocation.email}
                  address={{
                    street: fishermanBusiness.primaryLocation.street,
                    city: fishermanBusiness.primaryLocation.city,
                    state: fishermanBusiness.primaryLocation.state,
                    zip: fishermanBusiness.primaryLocation.zipCode,
                  }}
                />,
                <div>
                  <Image src={fishermanBusiness.gatsbyLogo.childImageSharp} />
                  <SocialMedia
                    socialMediaValues={fishermanBusiness.socialMedia}
                    buttonType={"circle"}
                    centerHeader={false}
                    colors={"secondary"}
                    groupButtons={false}
                    groupVertically={false}
                    header={<h6>Social</h6>}
                    inverted={false}
                    labelPosition={"free"}
                    showLabels={false}
                  />
                  <SiteMap
                    links={allFishermanBusinessWebsitePage.nodes}
                    horizontal={true}
                    bulleted={false}
                  />
                  <CopyrightLabel
                    company={fishermanBusiness.name}
                    phrase={"All Rights Reserved"}
                    privacyPolicyLink={
                      <OutboundLink
                        to={
                          "https://fisherman-static.s3.amazonaws.com/public/__fisherman/Client+Website+Privacy+Policy.pdf"
                        }
                        label={"Privacy Policy"}
                        eventLabel={"copyright-privacy-policy"}
                      />
                    }
                  />
                </div>,
                <HoursOfOperation
                  hours={fishermanBusiness.primaryLocation.hours}
                  displayOption="grouped"
                />,
              ]}
            />
          </div>
          <FishermanBanner />
        </React.Fragment>
      );
    }}
  />
);
